export default {
  adverts: state => state.adverts,
  ongoingBids: state => state.ongoingBids,
  getAdvertById: state => id => state.adverts.find(advert => advert.id === id)
}



// WEBPACK FOOTER //
// ./src/store/modules/adverts/getters.js